const supplierQuotation = {
  status: 'Trạng thái',
  productCode: "Mã hàng hóa",
  productName: "Tên sản phẩm",
  productModel: "Mô hình hàng hóa",
  productCount: "Số lượng hàng hóa",
  mrd: "Thời gian giao hàng dự kiến",
  deadline: 'Thời gian nộp bài muộn nhất',
  mpq: "Hợp đồng đóng gói tối thiểu",
  curMpq: "Đóng gói tối thiểu một lần",
  days: "Hợp đồng cung cấp chu kỳ",
  curDays: "chu kỳ cung cấp duy nhất",
  price: "Giá hợp đồng",
  curPrice: "Một lời đề nghị",
  curTotalPrice: 'Tổng giá trị một lần',
  submitTimer: "Đếm ngược để nộp đơn",
  operation: 'Hoạt động',
  handlePrice: "Báo giá",
  priceInfo: "Thông tin báo giá",
  rejected: "Bị từ chối",
  confirmQuotate: 'Có chắc chắn về báo giá không? ',
  confirmQuotateTip: 'Điều này sẽ gửi báo giá cho mặt hàng này',
};

export default supplierQuotation;